import React, { useCallback } from "react";
import { Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { useAtomValue } from "jotai";

import { stageConfigAtom } from "atoms/Ltool/stageConfigAtoms";
import { buildCalcLabel } from "atoms/recentCalcsAtom";
import { buildCsvBlob, buildCsvMetadataLines } from "utils/charts/csvMetadata";
import { buildChartCsv, makeChartCsvFileName, type MatrixChartCsvRow } from "../utils/exportChartCsv";

type Props = {
    chartData: MatrixChartCsvRow[];
    unitId: string | null;
    phenomenonGroupId: string | null;
    conditionId: string;
};

export const DownloadChartCsvButton: React.FC<Props> = ({ chartData, unitId, phenomenonGroupId, conditionId }) => {
    const config = useAtomValue(stageConfigAtom);

    const handleDownload = useCallback(() => {
        if (chartData.length === 0) return;

        const metaLines = buildCsvMetadataLines({
            calcSetName: buildCalcLabel(config),
            date: new Date(),
        });
        const csv = buildChartCsv(chartData, metaLines);
        // Excel 文字化け防止のため UTF-8 BOM 付き Blob を使う。
        const blob = buildCsvBlob(csv);
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = makeChartCsvFileName(unitId, phenomenonGroupId, conditionId);
        link.click();
        URL.revokeObjectURL(url);
    }, [chartData, config, conditionId, phenomenonGroupId, unitId]);

    return (
        <Button
            variant="outlined"
            size="small"
            startIcon={<DownloadIcon />}
            onClick={handleDownload}
            disabled={chartData.length === 0}
            sx={{ fontSize: "0.5rem" }}
        >
            download
        </Button>
    );
};
